import React from 'react';

function PodcastsPage() {
  // Example podcast data
  const podcasts = [
    {
      title: 'Mindful Moments',
      description: 'Weekly mindfulness practices and guided meditations.',
      audio: '/assets/audio/mindful-moments.mp3',
      image: '/assets/images/1/Podcasta.png',
      guest: 'Dr. Sarah Johnson'
    },
    {
      title: 'Real Talk: Mental Health',
      description: 'Conversations with experts and real people about mental health journeys.',
      audio: '/assets/audio/real-talk.mp3',
      image: '/assets/images/1/Podcasta.png',
      guest: 'Dr. Michael Chen'
    },
    {
      title: 'Coping Skills 101',
      description: 'Practical tips and stories for managing stress, anxiety, and more.',
      audio: '/assets/audio/coping-skills.mp3',
      image: '/assets/images/1/Podcasta.png',
      guest: 'Emma Wilson'
    }
  ];

  return (
    <>
      <section className="page-header">
        <div className="page-header__bg" style={{ backgroundImage: 'url(/assets/images/backgrounds/slider-2-2.jpg)' }}></div>
        <div className="container">
          <div className="page-header__inner">
            <h2 className="page-header__title">Podcasts</h2>
            <ul className="thm-breadcrumb">
              <li><a href="/">Home</a></li>
              <li><span>/</span></li>
              <li><span>Podcasts</span></li>
            </ul>
          </div>
        </div>
      </section>
      <section className="podcasts-section" style={{ background: '#fafbff', padding: '64px 0' }}>
        <div className="container">
          <div className="row justify-content-center">
            {podcasts.map((p, idx) => (
              <div className="col-lg-4 col-md-6 mb-4" key={idx}>
                <div style={{
                  background: 'rgba(255,255,255,0.95)',
                  borderRadius: '16px',
                  boxShadow: '0 4px 24px rgba(80,80,120,0.08)',
                  padding: '32px',
                  textAlign: 'center',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'space-between'
                }}>
                  <img src={p.image} alt={p.title} style={{ width: '90px', height: '90px', borderRadius: '18px', objectFit: 'cover', marginBottom: '18px', boxShadow: '0 2px 8px #7c3aed22' }} />
                  <h4 style={{ fontWeight: 700, color: '#2d2d4d', marginBottom: '6px' }}>{p.title}</h4>
                  <div style={{ color: '#7c3aed', fontWeight: 600, marginBottom: '10px' }}>{p.guest}</div>
                  <p style={{ color: '#444', fontSize: '1.05rem', marginBottom: '18px' }}>{p.description}</p>
                  <audio controls style={{ width: '100%', marginBottom: '10px' }}>
                    <source src={p.audio} type="audio/mpeg" />
                    Your browser does not support the audio element.
                  </audio>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default PodcastsPage;
